import Loading from "@@/core/components/shared/Loading/Loading";
import mixins from "@@/core/mixins/mixins";
import FormModal from "@@/core/libraries/form/FormModal";
import {
  BButton,
  BCard,
  BCollapse,
  BFormGroup,
  BFormInput,
  BTable,
  BTooltip,
  VBToggle,
} from "bootstrap-vue";

export default {
  name: "Havale",
  components: {
    FormModal,
    Loading,
    BTooltip,
    BButton,
    BCard,
    BTable,
    BCollapse,
    BFormGroup,
    BFormInput,
  },
  directives: {
    "b-toggle": VBToggle,
  },
  mixins: [mixins],
  data() {
    return {
      url: "admin/store-contradictions",
      fields: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "store.label",
          label: "انبار",
        },
        {
          key: "total_requested",
          label: "تعداد کل درخواست شده",
        },
        {
          key: "items_count",
          label: "تعداد مغایرت",
        },
        {
          key: "forgotten_items_count",
          label: "تعداد فراموش شده",
        },
        {
          key: "created_at",
          label: "تاریخ ثبت",
        },
        {
          key: "show",
          label: "نمایش",
        },
      ],
    };
  },
  mounted() {
    this.loadItems();
  },
  methods: {},
};
